import $ from 'jquery'

const PHONE_INPUT_SELECTOR = "[data-behavior='phone-input']"
const PHONE_INVALID_MESSAGE = 'Enter a valid 10-digit US phone number.'
let phoneMaskInitialized = false

const formatPhoneDigits = (value = '') => {
  const digits = value.replace(/\D/g, '').slice(0, 10)
  if (digits.length === 0) {
    return ''
  }

  if (digits.length < 4) {
    return `(${digits}`
  }

  if (digits.length < 7) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}

const applyPhoneMask = (input) => {
  const formatted = formatPhoneDigits($(input).val() || '')
  $(input).val(formatted)
}

const setPhoneValidity = (input) => {
  const digits = ($(input).val() || '').replace(/\D/g, '')
  if (digits.length === 0 || digits.length === 10) {
    input.setCustomValidity('')
  } else {
    input.setCustomValidity(PHONE_INVALID_MESSAGE)
  }
}

const initializeExistingInputs = () => {
  $(PHONE_INPUT_SELECTOR).each(function initMask() {
    applyPhoneMask(this)
    setPhoneValidity(this)
  })
}

const bindPhoneEvents = () => {
  $('body').on('input', PHONE_INPUT_SELECTOR, function handleInput() {
    applyPhoneMask(this)
    setPhoneValidity(this)
  })

  $('body').on('blur', PHONE_INPUT_SELECTOR, function handleBlur() {
    applyPhoneMask(this)
    setPhoneValidity(this)
  })

  $('body').on('focus', PHONE_INPUT_SELECTOR, function handleFocus() {
    this.setCustomValidity('')
  })

  $('body').on('submit', '.booking-form', function handleSubmit(event) {
    let firstInvalidField = null

    $(this).find(PHONE_INPUT_SELECTOR).each(function validateField() {
      applyPhoneMask(this)
      setPhoneValidity(this)
      const digits = ($(this).val() || '').replace(/\D/g, '')
      if (!firstInvalidField && digits.length > 0 && digits.length !== 10) {
        firstInvalidField = this
      }
    })

    if (firstInvalidField) {
      event.preventDefault()
      firstInvalidField.reportValidity()
    }
  })
}

const initPhoneInputMask = () => {
  if (phoneMaskInitialized) {
    return
  }
  phoneMaskInitialized = true
  bindPhoneEvents()
  initializeExistingInputs()
}

export { initPhoneInputMask }
